import React from "react";
import cx from "classnames";
interface InfoItem {
    title: string;
    value: string | JSX.Element;
}
interface IProps {
    data: InfoItem[],
    noMargin?: boolean
}
const InfoHeader: React.FC<IProps> = ({ data, noMargin }) => {
    return <div className={cx("KCL_infoHeader", { "noMargin": noMargin })}>
        {
            data.map((item) => (
                <div className="info-col" key={item.title}>
                    <div className="info-item">
                        <span className="title">{item.title}</span>
                        <span className="value">{item.value}</span>
                    </div>
                </div>
            ))
        }
    </div>
}

export default InfoHeader;